// apps/web/src/features/commercial-proposals/public/PublicProposalNotFound.tsx
//
// @aiSecurity GENERIC not-found state for the public surface (#1199).
//   IDENTICAL copy/markup for every failure reason — invalid, malformed,
//   draft, revoked, unknown, or a null token — so the page gives NO signal
//   about whether a proposal exists.
import { useTranslation } from 'react-i18next';

export function PublicProposalNotFound() {
  const { t } = useTranslation('commercialProposalsPublic');
  return (
    <main
      data-testid="cp-public-not-found"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--s-7)',
        background: 'var(--bg-0)',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: 420,
          textAlign: 'center',
          background: 'var(--bg-1)',
          border: '1px solid var(--border-1)',
          borderRadius: 'var(--r-3)',
          boxShadow: 'var(--shadow-2)',
          padding: 'var(--s-8)',
        }}
      >
        <h1
          style={{
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--fz-18)',
            fontWeight: 600,
            color: 'var(--fg-1)',
            margin: 0,
            marginBottom: 'var(--s-3)',
          }}
        >
          {t('notFound.title')}
        </h1>
        <p
          style={{
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--fz-13)',
            color: 'var(--fg-2)',
            margin: 0,
          }}
        >
          {t('notFound.body')}
        </p>
      </section>
    </main>
  );
}
